import {PictureOutlined, PlayCircleOutlined} from '@ant-design/icons';
import {Button} from '@ds/components';
import {useEffect, useMemo} from 'react';

type CaptureCardProps = {
  title: string;
  emptyText: string;
  buttonText: string;
  file: File | null;
  type: 'image' | 'video';
  onCapture: () => void;
};

const CaptureCard: React.FC<CaptureCardProps> = ({
  title,
  emptyText,
  buttonText,
  file,
  type,
  onCapture
}) => {
  const previewUrl = useMemo(() => (file ? URL.createObjectURL(file) : null), [file]);

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  return (
    <section className="flex flex-col gap-1.5">
      <h2 className="text-body-sm-emphasis text-gray-09">{title}</h2>
      <div className="flex items-center gap-1.5 rounded-md border border-gray-03 bg-gray-01 px-2 py-1.5">
        <span className="flex size-8 shrink-0 items-center justify-center text-body-lg text-gray-09">
          {type === 'video' ? <PlayCircleOutlined aria-hidden /> : <PictureOutlined aria-hidden />}
        </span>
        <div className="flex min-w-0 flex-1 items-center justify-between gap-2">
          {previewUrl ? (
            type === 'video' ? (
              <video
                src={`${previewUrl}#t=0.01`}
                muted
                playsInline
                preload="metadata"
                className="size-10 rounded-md object-cover"
              />
            ) : (
              <img
                src={previewUrl}
                alt="تصویر برداشت شده"
                className="size-10 rounded-md object-cover"
              />
            )
          ) : (
            <span className="whitespace-nowrap text-body-sm text-gray-05">{emptyText}</span>
          )}
          <Button size="md" className="min-w-30" onClick={onCapture}>
            {buttonText}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CaptureCard;
